var layoutTheme = {
  layout: {
    media: {
      xxs: 414,
      xs: 568,
      sm: 768,
      md: 1024,
      lg: 1366,
      xl: 1680
    },
    grid: {
      columns: 30,
      gutter: 16
    },
    maxSiteWidth: 1440,
    header: {
      mainHeight: '3.25rem',
      mobileMainHeight: '3.5rem',
      accountHeight: '1.875rem'
    },
    aside: {
      width: {
        lg: 400
      }
    }
  }
};
export default layoutTheme;